var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":_vm.fillColor,"id":"wave-one","viewBox":"0 0 1440 146","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1439.98 70.3892C1320.66 64.6381 1211.01 40.0638 1059.86 41.6735C811.943 44.3136 572.91 137.321 329.239 145.228H265.059C177.655 142.242 89.5083 126.425 0.000488281 89.7695V0H1439.98V70.3892Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }